import { PasswordActive, PasswordInactive } from 'assets/icons';
import { LoginManImage, Logo, LogoWhite } from 'assets/img';
import { Button, Input, Modal } from 'components';
import { useApacuana } from 'contexts/ApacuanaContext';
import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { RootState } from 'reducers';
import { AuthService } from 'services';
import { Constants, Globals } from 'utils';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
  apacuanaContext: any;
}

class Login extends React.Component<Props> {
  state = {
    form: {
      email: '',
      password: '',
    },
    activePassword: false,
    visible: false,
  };

  componentDidMount() {
    if (this.props.user) {
      this.props.history.replace('/');
    }

    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Iniciar Sesión',
        onBack: null,
      },
    });
  }

  submit = async (e: any) => {
    e.preventDefault();
    if (!this.state.form.email) {
      Globals.showError('Debe ingresar el correo electrónico');
      return;
    }
    if (!this.state.form.password) {
      Globals.showError('Debe ingresar la contraseña');
      return;
    }
    const res: any = await AuthService.login(this.state.form);
    await this.props.dispatch({
      type: 'SET_USER',
      payload: res.user,
    });
    await this.props.dispatch({
      type: 'SET_AUTH_TOKENS',
      payload: {
        access_token: res.access_token,
        refresh_token: res.refresh_token,
      },
    });

    // Si llegó con ?next=... (ej. desde un link de membresías), volvemos ahí.
    const params = new URLSearchParams(this.props.location.search);
    const next = params.get('next');
    this.props.history.replace(next ? decodeURIComponent(next) : '/home');
  };

  change = (e: any) => {
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  openRegister = (e: any) => {
    e.preventDefault();
    this.setState({
      visible: true,
    });
  };

  selectLevel = (level: number) => {
    this.setState({ visible: false });
    this.props.history.push(`/register/${level}`);
  };

  render() {
    const { visible } = this.state;

    return (
      <div id='login'>
        <Modal
          className='modal-select-level'
          visible={visible}
          centered
          title=''
          onClose={() => this.onClose()}
        >
          <div id='modal-select-level'>
            <div className='text-center'>
              <img src={LogoWhite} className='logo-white' />
            </div>
            <p className='subtitle'>¿CÓMO DESEA REGISTRARSE?</p>

            <div className='tab-navigator'>
              <button
                type='button'
                className='tab-item'
                onClick={() => this.selectLevel(Constants.LEVELS.LAWYER)}
              >
                ABOGADO
              </button>
              <button
                type='button'
                className='tab-item'
                onClick={() => this.selectLevel(Constants.LEVELS.CLIENT)}
              >
                USUARIO
              </button>
            </div>
          </div>
        </Modal>

        <div className='container-black'>
          <div className='row container-form container-bg'>
            <div className='col-lg-4'>
              <div className='form-align form-align-responsive'>
                <form onSubmit={this.submit}>
                  <div className='container-logo text-center'>
                    <img src={Logo} />
                  </div>
                  <div className='container-input'>
                    <div className='input-group'>
                      <Input placeholder='Correo Electrónico' name='email' onChange={this.change} />
                    </div>
                    <div className='input-group'>
                      <Input
                        placeholder='Contraseña'
                        type={this.state.activePassword ? 'text' : 'password'}
                        name='password'
                        onChange={this.change}
                      />
                      <div
                        className='input-group-prepend password-view'
                        onClick={() => {
                          this.setState({
                            activePassword: !this.state.activePassword,
                          });
                        }}
                      >
                        <img src={this.state.activePassword ? PasswordActive : PasswordInactive} />
                      </div>
                    </div>
                    <div className='text-center'>
                      <Button type='submit'>Iniciar Sesión</Button>
                    </div>
                    <div className='row'>
                      <div className='col-md-12 text-center'>
                        <div className='register'>
                          <Link to='/register' onClick={(e: any) => this.openRegister(e)}>
                            Registrar
                          </Link>
                        </div>
                      </div>
                      <div className='col-md-12 text-center'>
                        <div className='recover'>
                          <Link to='/recover'>Recuperar contraseña</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className='col-lg-8 text-center container-showcase'>
              <div className='showcase-triangle showcase-triangle-top' />
              <div className='showcase-blob showcase-blob-top' />
              <div className='showcase-visual'>
                <div className='showcase-orange-blob' />
                <img src={LoginManImage} className='showcase-image' />
              </div>
              <div className='showcase-blob showcase-blob-bottom' />
              <div className='showcase-triangle showcase-triangle-bottom' />
            </div>
            <div className='showcase-content'>
              <h1 className='showcase-title'>Legalmente</h1>
              <div className='showcase-banner'>
                <p>innovación, transparencia y accesibilidad.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const LoginWithApacuana = (props: Props) => {
  const apacuanaContext: any = useApacuana();

  return <Login {...props} apacuanaContext={apacuanaContext} />;
};

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(LoginWithApacuana);
